// 我的工单
<template>
  <el-card class="card-main">
    <el-radio-group v-model="activeName" @change="onSearch" class="radioGroup">
      <el-radio-button label="0">我的待办</el-radio-button>
      <el-radio-button label="1">我发起的</el-radio-button>
      <el-radio-button label="2">我参与的</el-radio-button>
    </el-radio-group>
    <div class="main">
      <el-form ref="searchInfo" :model="searchInfo" class="global-form" :inline="true">
        <el-form-item>
          <el-select v-model="searchInfo.projectId" placeholder="请选择所属项目" filterable clearable @change="getTypeList">
            <el-option
              v-for="item in projectList"
              :key="item.projectId"
              :label="item.projectName"
              :value="item.projectId"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-select v-model="searchInfo.orderType" placeholder="请选择工单类型" :disabled="!searchInfo.projectId" filterable clearable>
            <el-option
              v-for="item in typeList"
              :key="item.orderType"
              :label="item.orderTypeName"
              :value="item.orderType"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item prop="orderTitle">
          <el-input v-model="searchInfo.orderTitle" clearable placeholder="请输入工单编号"/>
        </el-form-item>
        <el-form-item prop="orderStatus">
          <el-select v-model="searchInfo.orderStatus" placeholder="请选择工单状态" clearable>
            <el-option v-for="(item, index) in statusList" v-show="activeName !== '0' || index < 2" :key="index" :label="item" :value="index"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item prop="orderUserName" v-if="activeName !== '0'">
          <el-input v-model="searchInfo.orderUserName" clearable placeholder="请输入当前处理人"/>
        </el-form-item>
        <el-form-item>
          <el-date-picker v-model="dateArr" value-format="yyyy-MM-dd" start-placeholder="开始日期" end-placeholder="结束日期" type="daterange" placeholder="请选择日期" @change="dateChange"></el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" class="medium" @click="onSearch">查询</el-button>
        </el-form-item>
      </el-form>
      <div class="mb20">
        <el-button type="primary" icon="el-icon-plus" @click="onAdd" v-show="$ButtonShow('YOD_ADD_01')">新增工单</el-button>
      </div>
      <el-table ref="table" class="global-table" stripe v-loading="loading" :data="tableData">
        <el-table-column label="工单编号" min-width="100px" show-overflow-tooltip prop="orderId">
        </el-table-column>
        <el-table-column label="所属项目"  min-width="100px" show-overflow-tooltip prop="projectName">
          <template v-slot="{ row }">
            <span>{{row.projectState === '3' ? getState(row.projectState) + '—' + row.projectName : row.projectName}}</span>
          </template>
        </el-table-column>
        <el-table-column label="工单类型" min-width="100px" show-overflow-tooltip prop="orderTypeName">
        </el-table-column>
        <el-table-column label="工单内容" min-width="100px" show-overflow-tooltip prop="orderContent">
        </el-table-column>
        <el-table-column label="工单截止日期" min-width="100px" show-overflow-tooltip prop="orderDate">
        </el-table-column>
        <el-table-column label="状态" min-width="100px" show-overflow-tooltip prop="orderStatus">
          <template v-slot="{ row }">
            <span>{{ getStatusName(row.orderStatus) }}</span>
          </template>
        </el-table-column>
        <el-table-column v-if="activeName !== '0'" label="当前处理人" min-width="100px" show-overflow-tooltip prop="orderUserName">
        </el-table-column>
        <el-table-column prop="createUserName" label="创建人"></el-table-column>
        <el-table-column width="160" prop="ctime" label="创建时间"></el-table-column>
        <el-table-column label="操作" width="180px" fixed="right">
          <template v-slot="{ row }">
            <el-button type="text" @click="onDetailShow(row, '4')">查看</el-button>
            <span style="marginLeft: 10px;" v-if="(row.orderStatus === '0' || row.orderStatus === '1') && userInfo.userId === row.orderUserId">
              <el-button type="text" @click="onDetailShow(row)">处理</el-button>
              <el-button type="text" @click="onDetailShow(row, '2')">转办</el-button>
            </span>
            <el-button style="margin-left: 10px;" type="text" @click="onDetailShow(row, '3')" v-if="row.createUserId === userInfo.userId && row.orderStatus !== '3' && row.orderStatus !== '2'">关闭</el-button>
          </template>
        </el-table-column>
      </el-table>
      <global-pagination
        :total="total"
        :current-page.sync="page"
        :page-size.sync="size"
        @current-change="getData"
        @size-change="getData"
      ></global-pagination>
      <OrderDetailDialog v-if="detailShow" :detailShow="detailShow" :isMyOrder="true" :orderId='orderId' :handleType='handleType' @closeDialog="closeDialog"></OrderDetailDialog>
    </div>
  </el-card>
</template>

<script>
import OrderDetailDialog from './OrderDetailDialog.vue'

//
export default {
  name: 'MyOrder',
  components: {
    OrderDetailDialog
  },
  data () {
    return {

      activeName: '0',
      searchInfo: {
        projectId: '',
        orderType: '',
        orderTitle: '',
        orderStatus: '',
        orderUserName: '',
        startTime: '',
        endTime: ''
      },

      total: 0,
      page: 1,
      size: 10,
      loading: false,
      tableData: [],
      typeList: [],
      dateArr: [],
      statusList: ['待反馈', '待审核', '已完成', '已关闭'],

      detailShow: false,
      handleType: '0', // 处理类型 4：查看 0：反馈 1：审核 2：转办 3：关闭
      orderId: ''
    }
  },
  computed: {
    projectList () {
      return this.$store.state.projectList
    },
    userInfo () {
      return JSON.parse(sessionStorage.getItem('userInfo'))
    }
  },

  created () {
    this.getData()
  },

  activated () {
    this.getData()
  },
  methods: {
    getTypeList () {
      this.searchInfo.orderType = ''
      this.$axios.get(this.$apis.workOrder.selectWorkOrderTypeByList, {
        projectId: this.searchInfo.projectId,
        orderTypeStatus: '1'
      }).then((res) => {
        this.typeList = res.list || []
      })
    },

    getData () {
      const infoList = [
        {
          orderUserId: this.userInfo.userId
        },
        {
          createUserId: this.userInfo.userId
        },
        {
          myOrder: this.userInfo.userId
        }
      ]
      this.loading = true
      this.$axios.get(this.$apis.workOrder.selectWorkOrderByPage, {
        ...this.searchInfo,
        ...infoList[Number(this.activeName)],
        page: this.page,
        size: this.size
      }).then((res) => {
        this.total = res.total || 0
        this.tableData = res.list || []
      }).finally(() => {
        this.loading = false
      })
    },

    onSearch () {
      this.page = 1
      this.getData()
    },

    dateChange (date) {
      if (date) {
        this.searchInfo.startTime = date[0]
        this.searchInfo.endTime = date[1]
      } else {
        this.searchInfo.startTime = ''
        this.searchInfo.endTime = ''
      }
    },

    getState (state) {
      const arr = ['', '未开工', '在建', '已移交']
      return arr[Number(state)]
    },

    getStatusName (orderStatus) {
      return this.statusList[Number(orderStatus)]
    },

    onAdd () {
      this.$router.push({ name: 'myOrderAdd' })
    },

    onDetailShow (row, type) {
      if (type) {
        this.handleType = type
      } else {
        this.handleType = row.orderStatus || ''
      }
      this.orderId = row.orderId || ''
      this.detailShow = true
    },

    closeDialog () {
      this.detailShow = false
      this.getData()
    }

  }

}
</script>

<style scoped lang="scss">
  ::v-deep .el-card__body {
    padding: 0 !important;
  }
  .main {
    width: 100%;
    padding: 20px 40px;
    border-top: 1px solid #F4F4F4;
  }
</style>
